import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { buildFilterSelectorLabels } from "@/shared/composables/filterSelectorLabels";
import { secondaryLanguages } from "../../domain/valueListValue";
/** The table chrome both value-list screens share: language columns, column settings, inert filters. */
export function useValueListTable() {
    const { t, locale } = useI18n();
    /** Headers of the non-identity language columns, keyed `<prefix>-<language>`. */
    function secondaryLanguageHeaders(prefix) {
        return Object.fromEntries(secondaryLanguages(locale.value).map((language) => [
            `${prefix}-${language}`,
            t("valueLists.columns.language", {
                name: t(`valueLists.languages.${language}`),
                code: language.toUpperCase(),
            }),
        ]));
    }
    /** The identity column is pinned and never hideable; the others start visible unless listed. */
    function toSettingsColumns(headers, identityKey, hiddenByDefault = []) {
        return Object.entries(headers).map(([key, label]) => ({
            key,
            label,
            visible: !hiddenByDefault.includes(key),
            pinned: key === identityKey,
            alwaysVisible: key === identityKey,
        }));
    }
    // CONSTRAINT: inert on purpose until the PO specifies the pre-filtered lists; an empty menu is the
    // whole behaviour today.
    const tabDropdowns = computed(() => [
        { label: t("table.tabs.preFilteredLists"), iconLeft: "ri-equalizer-line", items: [] },
    ]);
    const filterSelectorLabels = computed(() => buildFilterSelectorLabels(t));
    // CONSTRAINT: the fields carry no values on purpose until the story that owns filtering specifies
    // them; add the values together with the selector's @apply handler.
    function inertFilterFields(fields) {
        return fields.map((field) => ({
            ...field,
            type: "list",
            items: [],
            selectAllLabel: t("table.selectAll"),
            step2SearchPlaceholder: t("filters.quick.searchValue"),
        }));
    }
    return { secondaryLanguageHeaders, toSettingsColumns, tabDropdowns, filterSelectorLabels, inertFilterFields };
}
